// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__xJckQ","fadeInOut":"styles_fadeInOut__S9bek","loader":"styles_loader__D4cFj"};